<template>
  <div id="welcome-email" class="row justify-content-center">
    <div v-if="registration._id" class="col-12 col-md-7">
      <card class="mt-5 mb-5 test" >
        <div v-if="registration.event.logo && registration.event.logo._id" class="form-text">
           <img :src="baseUrl + registration.event.logo.path" width="100px"/>
        </div>
        <h3 class="invoice-page-title" style="background-color: #25a5f5 !important; color: #fff !important; text-align:center !important; padding-top: 5px; !important">
          <span v-if="registration.status=='pending' && !registration.event.onlinePaymentOnly">Your registration for {{registration.event.name }} is in a <span style="color: red;">PENDING Status</span>.</span>
          <span v-else-if="registration.status=='pending' && registration.event.onlinePaymentOnly">Your registration for {{registration.event.name }} is in a <span style="color: red;">PENDING Status</span>. Please make a payment to submit your registration.</span>
          <span v-else>Thank you for submitting your registration for {{ registration.event.name }}</span>
          <sub v-if="isUserLoggedIn">
            (
            <router-link
              :to="registration.parent != undefined ? '/dashboard/' + registration.parent.event + '/attendees/' + registration.parent._id : '/dashboard/' + registration.event._id + '/attendees/' + registration._id"
            >View Registration</router-link>)
          </sub>

        </h3>
        <h5 class="date-heading" style="background-color: #25a5f5 !important; color: #fff !important; text-align:center !important; padding-top: 5px; !important; margin-bottom:5px;">Dates: {{ registration.event.startDate | startDate }} to {{ registration.event.endDate | endDate }}</h5>
        <div v-if="registration.status=='pending'">
          <p v-if="registration.event.enablePaypal" style="font-size:10px; font-weight:bold; margin:0; margin-top: 10px;">* If you have just made a payment through PayPal, please allow us a few minutes to process your request.</p>
          <p style="font-size:10px; font-weight:bold; margin: 0; margin-top: 5px;">* You will receive a confirmation mail upon successful payment.</p>
          <p v-if="registration.event.enablePaypal" style="font-size:10px; font-weight:bold; margin-top: 5px;">* Please refresh this page in a few minutes for the updated status.</p>
        </div>
        
        <table class="table">
          <tbody>
            <!-- <tr>
              <th>Event Name</th>
              <td>{{ registration.event.name }}</td>
            </tr> -->
            <tr>
              <th style="width:150px;">Registration Number</th>
              <td>{{ registration.confirmationNumber }}</td>
            </tr>
            <!-- <tr>
              <th>When</th>
              <td>From the {{ registration.event.startDate | startDate }} to the {{ registration.event.endDate | endDate }}</td>
            </tr> -->
            <!-- <tr>
              <th>Where</th>
              <td>{{ registration.event.address }}</td>
            </tr> -->
            <tr>
              <th>Primary Registrant</th>
              <td>{{ registration | firstName }} {{ registration | lastName }}  <span v-if="registration.allActivityName.length">{{registration.allActivityName | displayActivity }}</span></td>
            </tr>
            <tr>
              <th>E-Mail</th>
              <td>{{ registration | email }}</td>
            </tr>
            <tr>
              <th>Type</th>
              <td>{{ registration.type.name }}</td>
            </tr>
            <!-- <tr>
              <th>Payment Method</th>
              <td>{{ registration.paymentMethod }}</td>
            </tr> -->
            <tr>
              <th>Additional Registrants</th>
              <td>
                <span
                  v-for="(registrant, index) in childRegistrations"
                  :key="`child-registration-${index}`"
                >
                  {{ registrant | name }}
                  <span v-if="registrant.allActivityName.length && registration.event.displayActivitiesTogetherWithRegistrantNames">{{registrant.allActivityName | displayActivity }}</span>
                  <div v-if="index+1 != childRegistrations.length" style="height:1px; background-color:#575757; margin:15px 0;"></div>
                </span>
              </td>
            </tr>
            <tr>
              <th>Registration Date</th>
              <td>{{ registration.createdAt | registrationDate }}</td>
            </tr>
            <tr>
              <th>Total Registrants</th>
              <td>{{ getTotalRegistrants }}</td>
            </tr>
            <tr>
              <th>Payment Status</th>
              <td>{{ getPaymentStatus }}</td>
            </tr>
          </tbody>
        </table>

        <table v-if="!registration.parent" class="table table-bordered calculation-table">
          <!-- <tr v-if="childRegistrations.length">
            <th>Primary Total</th>
            <td align="right">{{ registration.primaryRegistrantTotal }} USD</td>
          </tr> -->
          <tr v-if="isUserLoggedIn || !registration.event.hideAllPaymentInfoFromRegistrant">
            <th class="text-center" style="background-color: #25a5f5 !important; color: #fff !important; text-align:center !important; padding-top: 5px; !important">Total  : {{ registration.event.appCurrency }} {{ parseFloat(registration.total).toFixed(2) }}</th>
            <!-- <td align="right"></td> -->
             <th class="text-center" style="background-color: #25a5f5 !important; color: #fff !important; text-align:center !important; padding-top: 5px; !important">Paid  : {{ registration.event.appCurrency }} {{ parseFloat(registration.paid).toFixed(2) }}</th>
            <!-- <td align="right"></td> -->
            <th class="text-center" style="background-color: #25a5f5 !important; color: #fff !important; text-align:center !important; padding-top: 5px; !important">Balance Due  : {{ registration.event.appCurrency }} {{ parseFloat(registration.due).toFixed(2) }}</th>
           <!--  <td align="right">


            </td> -->

          </tr>
          <!-- <tr>
            <td colspan="3"></td>
          </tr> -->
         <!--  <tr>
            <th>Paid</th>
            <td align="right">{{ registration.paid }} USD</td>
          </tr> -->


         <!--  <tr v-if="registration.due > 0">
            <th>Due</th>
            <td align="right">
              {{ registration.due }} USD

            </td>
          </tr> -->
        </table>

        <div v-if="(isUserLoggedIn || !registration.event.hideAllPaymentInfoFromRegistrant) && registration.due > 0">
          
          <details open class="my-3">
            <summary>Payment</summary>
            <div class="d-flex my-3" style="gap:20px; align-content: center">
              <p class="m-0" v-if="registration.event.enablePaypal || registration.event.enableZelle || registration.event.enableStripe">Pay with: </p>
              <div class="d-flex" style="gap:10px;">
                <label v-if="registration.event.enablePaypal" @click="paymentMethod = 'paypal'" for="paypal_radio" style="cursor: pointer; display: flex; align-items:center; gap:10px; margin: 0;" :style="`order:${registration.event.paypalDisplayOrder}`">
                  <input type="radio" id="paypal_radio" :checked="paymentMethod == 'paypal'" style="cursor: pointer;" name="payment_mode" value="paypal">
                  <span>Paypal</span>
                </label>
      
                <label v-if="registration.event.enableZelle" @click="paymentMethod = 'zelle'" for="zelle_radio" style="cursor: pointer; display: flex; gap:10px; align-items: center; margin: 0;" :style="`order:${registration.event.zelleDisplayOrder}`">
                  <input type="radio" id="zelle_radio" :checked="paymentMethod == 'zelle'" style="cursor: pointer;" name="payment_mode" value="zelle">
                  <span>{{ registration.event.paymentProviderName }}</span>
                </label>

                <label v-if="registration.event.enableStripe" @click="paymentMethod = 'stripe'" for="stripe_radio" style="cursor: pointer; display: flex; gap:10px; align-items: center; margin: 0;" :style="`order:${registration.event.stripeDisplayOrder}`">
                  <input type="radio" id="stripe_radio" :checked="paymentMethod == 'stripe'" style="cursor: pointer;" name="payment_mode" value="stripe">
                  <span>Credit/Debit Cards(stripe)</span>
                </label>
              </div>
              <span v-if="(registration.event.allowDeposit || registration.event.onlinePaymentOnly) && minimum_amt_to_pay">( Minimum Amount Required: {{ registration.event.appCurrency }} {{ minimum_amt_to_pay }} )</span>
              <span v-else >( Due: {{ registration.event.appCurrency }} {{ registration.total - registration.paid }} )</span>
            </div>
            
            <table v-if="paymentMethod == 'paypal' && registration.event.enablePaypal" class="table payment-table">
              <tr>
                  <td class="text-right">
                    <p style="color:green;font-size: 12px;font-weight: bold;">Please enter amount you wish to pay :
                      <span v-if="registration.event.allowDeposit || registration.event.onlinePaymentOnly">(Minimum amount Required: {{ registration.event.appCurrency }} {{ minimum_amt_to_pay }})</span>
                      <!-- span v-if="!registration.event.allowDeposit && registration.event.onlinePaymentOnly">(Minimum amount Required: USD {{ registration.due }})</span -->
                    </p>
                    <el-input
                      v-model="customAmountInput"
                      type="number"
                      style="width: 200px"
                      class="mr-3 mb-2"
                      :min="minimum_amt_to_pay"
                    >
                      <template slot="prepend">{{ registration.event.appCurrency }}</template>
                    </el-input>
                    <!-- <p v-if="minimumPayableErrorFlag"
                      class="w-100 font-weight-bold font-italic show-desktop"
                      style="font-size: 12px;  color: red;"
                    >You need to pay minimum amount ({{registration.event.depositAmount}})</p> -->
                    <p
                      v-if="registration.event.onlinePaymentProcessingFee"
                      class="w-100 font-weight-bold font-italic show-desktop"
                      style="font-size: 12px;  color: green;"
                    >For online payments, a {{ registration.event.onlinePaymentProcessingFee }}% fee will be applied</p>
                    <p
                       class="text-right font-weight-bold font"
                             style="font-size: 12px; color:red">
                               No PayPal account? Click on the 'PayPal Checkout' button and look for 'Pay with Debit Or Credit Card'
                    </p>
                  </td>
                  <td class="text-left">
                    <paypal v-if="!minimumPayableErrorFlag"
                      currency="USD"
                      :amount="`${customAmount}`"
                      :env="registration.event.paypalSandboxMode ? 'sandbox' : ''"
                      :notify-url="notifyUrl"
                      :invoice-number="`${registration._id}-${timestamp}`"
                      :button-style="{ color: 'blue' }"
                      @payment-completed="onPaymentSuccess"
                      :client="{
                                                sandbox: registration.event.paypalSandboxClientId,
                                                production: registration.event.paypalClientId
                                            }"
                    />
                    <div v-if="minimumPayableErrorFlag" v-on:click="showAlert">
                      <img src="@/assets/img/paypal_button.png">
                    </div>
                    <p style="white-space: nowrap;"><span style="font-size:18px;">(</span><img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppmcvdam.png" alt="Buy now with PayPal" style="height:25px;" /><span style="font-size:18px;">)</span></p>
                     <p
                      v-if="registration.event.onlinePaymentProcessingFee"
                      class="w-100 font-weight-bold font-italic show-mobile"
                      style="font-size: 12px; color: green;"
                    >For online payments, a {{ registration.event.onlinePaymentProcessingFee }}% fee will be applied</p>
                  </td>
              </tr>
              <!-- <tr  v-else>
    
                Make payment with primary registration
    
              </tr> -->
            </table>
            <div v-if="paymentMethod == 'zelle' && registration.event.enableZelle">
              <hr>
              <div v-html="registration.event.zelleDescription" class="ql-editor"></div>
            </div>
            <div v-if="paymentMethod == 'stripe' && registration.event.enableStripe">
              <p style="color:green;font-size: 12px;font-weight: bold;">Please enter amount you wish to pay :
                <span v-if="registration.event.allowDeposit || registration.event.onlinePaymentOnly">(Minimum amount Required: {{ registration.event.appCurrency }} {{ minimum_amt_to_pay }})</span>
              </p>

              <div class="d-flex mb-2" style="align-items: center;">
                <el-input
                  v-model="customAmountInput"
                  type="number"
                  style="width: 200px;"
                  class="mr-3"
                  :min="minimum_amt_to_pay"
                >
                  <template slot="prepend" style="height: max-content;">{{ registration.event.appCurrency }}</template>
                </el-input>
  
                <StripePayment :cancel_url="getCurrentUri + '?cancel=true'" :success_url="getCurrentUri + '?success=true'" position="left" :amount="Number(customAmountInput)" :registration="registration"/>
              </div>
              <p v-if="registration.event.onlinePaymentProcessingFee" class="w-100 font-weight-bold font-italic show-desktop" style="font-size: 12px;  color: green;">For online payments, a {{ registration.event.onlinePaymentProcessingFee }}% fee will be applied</p>
            </div>
          </details>





        </div>


        <table v-if="registration.event.showEditMyRegistration" class="table calculation-table">
          <tr>
            <th class="text-center" style="background-color: #25a5f5 !important; color: #fff !important; text-align:center !important; padding-top: 5px; !important">To Edit Registration:
            <!-- <td  style="word-break:break-all;"> -->
              <router-link :to="`/evt/${registration.event._id}/types?email=${primaryEmail}&confno=${registration.confirmationNumber}`" target='_blank'>
                Click Here<!-- {{regEditLink}} -->
              </router-link>
            </th>
          </tr>
          <tr>
            <th class="text-center" style="background-color: #25a5f5 !important; color: #fff !important; text-align:center !important; padding-top: 5px; !important">
              Homepage: <a :href="`https://${registration.event.website}`" target="_blank">Click Here</a>
            </th>
          </tr>
        </table>

        <div v-html="registration.welcomeEmail"></div>

        <div class="row">
          <img :src="$store.state.baseUrl + registration.qr" width="192px" v-if="registration.event.qrOnConfirmationEmailAndConfirmationPage" />
        </div>
        <div class="row">
          <div class="col" v-if="!registration.event.dontShowMapOnConfirmationPage">
            <gmap-map
              v-if="mapOptions.center"
              :center="mapOptions.center"
              :zoom="7"
              :options="mapOptions"
              style="width: 100%; height: 300px"
            >
              <gmap-marker
                v-if="registration.event.location && registration.event.location.lat && registration.event.location.lng"
                :position="registration.event.location"
              />
            </gmap-map>
          </div>
        </div>

        <p class="copyright">
          {{$version? `${$version} |`:'' }} All rights reserved eventscoded.com | Questions/Support:
          <a
            href="mailto:info@eventscoded.com"
          >info@eventscoded.com</a>
        </p>
      </card>
    </div>
  </div>
</template>
<style>
  .invoice-page-title{
    margin-bottom:10px;
    font-size:23px;
  }
  .invoice-page-title sub{
    bottom:0;
  }
  .date-heading{
        font-size: 15px;
    margin-top: -10px;
    font-weight: 600;

  }
  .show-mobile{
    display: none;
  }
  .test .card-body {
    padding: 35px 35px 35px 35px !important;
  }
  @media only screen and (max-width:767px){
    .calculation-table, .calculation-table tr, .calculation-table th, .calculation-table td{
      display: block;
      width: 100%;
      text-align:right !important;
    }
    .payment-table, .payment-table tr, .payment-table tr td{
       display: block;
      width: 100%;
      border:none;
      padding:0;
    }
    .payment-table tr td.text-left{
      text-align: right !important;
    }
     .payment-table tr td p{
      margin-bottom:0;
     }
      .show-mobile{
    display: block;
  }
  .show-desktop{
    display: none;
  }
  }

</style>
<script>
import moment from "moment";
import http from "../http.js";
import Paypal from "vue-paypal-checkout";
import swal from "sweetalert2";
import { mapState } from "vuex";
import StripePayment from "../components/StripePayment.vue"

export default {
    components: {
        Paypal,
        StripePayment
    },
    data () {
        return {
            isUserLoggedIn: false,
            registration: {},
            childRegistrations: [],
            timestamp: new Date().getTime(),
            customAmount: "0",
            customAmountInput: 0,
            notifyUrl: "",
            primaryEmail: '',
            regEditLink: '',
            mapOptions: {
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
              disableDefaultUi: false,
              center: null,
            },
            minimumPayableErrorFlag: false,
            minimum_amt_to_pay: 0,
            paymentMethod: "paypal"
        }
    },
    computed: {
        ...mapState(["baseUrl", 'event', 'user']),
        getPaymentStatus(){
          let total = this.registration.total;
          let paid = this.registration.paid;
          let status = (this.registration.due <= 0) ? "Fully Paid" : paid <= 0 ? "Payment Pending" : "Partial Payment Made";
          return status
        },
        getTotalRegistrants(){
          let count = 1;
          count = count + this.registration.registrants.length
          return count
        },
        getCurrentUri(){
          return window.location.href
        },
        success(){
          return this.$route.query.success
        },
        cancel(){
          return this.$route.query.cancel
        },
    },
  watch: {
    customAmountInput: "onCustomAmountChange",
    success(nv){
      if(nv && nv == 'true'){
        this.showSuccessModal()
      }
    },
    cancel(nv){
      if(nv && nv == 'true'){
        this.showCancelModal()
      }
    },
  },
  mounted() {
    this.getRegistration();
    this.checkUserToken();
    if(this.success && this.success == 'true') this.showSuccessModal()
    if(this.cancel && this.cancel == 'true') this.showCancelModal()

    setTimeout(()=>{
      this.getRegistration();
    }, 2000)
  },
  methods: {
    setPaymentMethod(){
      let method = "paypal"
      let methods = []
      if(this.registration.event.enableZelle) methods.push({method: "zelle", order: this.registration.event.zelleDisplayOrder})
      if(this.registration.event.enableStripe) methods.push({method: "stripe", order: this.registration.event.stripeDisplayOrder})
      if(this.registration.event.enablePaypal) methods.push({method: "paypal", order: this.registration.event.paypalDisplayOrder})

      methods.sort((a,b) =>  Number(a.order) - Number(b.order))

      method = methods[0].method
      
      this.paymentMethod = method
    },
    removeQueries(){
      let fullPath = this.$route.fullPath
      fullPath = fullPath.replace("?success=true", "")
      fullPath = fullPath.replace("?cancel=true", "")
      this.$router.replace({ path: fullPath })
    },
    showSuccessModal(){
      this.removeQueries()
      swal.fire('Payment Request Submitted!', 'Please allow us a few minutes while we hear from Stripe. We will email you with the updated status shortly', 'success')
      .then(() => {
        this.$router.push({ name: 'welcome-email', params: { registrationId: this.$route.params.registrationId } })
      })
    },
    showCancelModal(){
      swal.fire('Payment Aborted!', 'Payment did not go through, please try again', 'error')
      .then(() => {
        this.removeQueries()
      })
    },
    checkUserToken: function() {
      if (localStorage.token != undefined && localStorage.token) {
        this.isUserLoggedIn = true;
      }
    },
        getRegistration: async function () {
            try {
                const response = await http.get(
                  `/api/registrations/${
                    this.$route.params.registrationId
                  }?withChildregistrations=true&withConfirmedRegistrantTotal=true`
                );
                const registration = response.data.registration;
                let due = registration.total - registration.paid;
                this.customAmountInput = due;
                //this.minimum_amt_to_pay = registration.event.allowDeposit
                //                            ? ((registration.event.depositAmount - registration.paid ) > 0 ? registration.event.depositAmount - registration.paid : 0 )
                //                            : (registration.event.onlinePaymentOnly ? registration.total - registration.paid : 0 )
                if (registration.event.allowDeposit){
                  if (registration.total < registration.event.depositAmount){
                    this.minimum_amt_to_pay = registration.total - registration.paid;
                  }else{
                        if((registration.event.depositAmount - registration.paid ) > 0){
                          this.minimum_amt_to_pay = registration.event.depositAmount - registration.paid;
                        }else{
                          this.minimum_amt_to_pay = 0;
                      }
                  }
                }else{
                  if (registration.event.onlinePaymentOnly){
                    this.minimum_amt_to_pay = registration.total - registration.paid;
                  }else{
                    this.minimum_amt_to_pay= 0;
                  }
                }

                //console.log('@@minimum_amt_to_pay', this.minimum_amt_to_pay, registration.event.allowDeposit, registration.event.onlinePaymentOnly, registration.due)
                registration.allActivityName = [...registration.fieldBasedActivities, ...registration.registeredActivities].map(acivity=>acivity.name );
                this.registration = {
                  ...registration,
                  welcomeEmail: await this.renderWelcomeEmail(registration),
                  due,
                  totalConfirmedRegistrant: response.data.totalConfirmedRegistrant
                };

                // Set payment method
                this.setPaymentMethod();

                this.notifyUrl = `${this.baseUrl}api/payments/paypal/${
                  this.registration.event.paypalSandboxMode ? "sandbox" : "live"
                }`;
                if (registration.event.onlinePaymentProcessingFee) {
                  due += (due * parseFloat(registration.event.onlinePaymentProcessingFee)) / 100;
                }
                this.customAmount = due;
                this.childRegistrations = response.data.childRegistrations;
                this.childRegistrations = this.childRegistrations.map(registration=>{
                  return registration = {...registration, allActivityName:[...registration.fieldBasedActivities, ...registration.registeredActivities].map(acivity=>acivity.name )}
                })

                if (
                  this.registration.event.location &&
                  this.registration.event.location.lat &&
                  this.registration.event.location.lng
                ) {
                  this.mapOptions.center = {
                    lat: this.registration.event.location.lat,
                    lng: this.registration.event.location.lng
                  };
                }

              const mapping = registration.fields.find(
                field => field.fieldMapping === "email"
              );
              if (mapping) {
                this.primaryEmail = mapping.value;
              }
              this.regEditLink = `${window.location.protocol}//${window.location.host}/evt/${registration.event._id}/types?email=${this.primaryEmail}&confno=${registration.confirmationNumber}`

              } catch (e) {
                this.$store.dispatch("handleErrors", e);
                console.log("error getting registration data");
              }
        },
    onCustomAmountChange: function() {
      this.customAmount = parseFloat(this.customAmountInput);
      let minimumPayable = this.registration.event.depositAmount > this.registration.due
                            ? this.registration.due : this.registration.event.depositAmount
      //console.log(this.minimum_amt_to_pay ,this.customAmount )
      if( this.minimum_amt_to_pay > this.customAmount ){
        this.minimumPayableErrorFlag = true
      }else{
        this.minimumPayableErrorFlag = false
      }
      if (this.registration.event.onlinePaymentProcessingFee) {
        this.customAmount +=
          (parseFloat(this.customAmount).toFixed(2) *
            parseFloat(this.registration.event.onlinePaymentProcessingFee).toFixed(2)) /
          100;
      }
      this.customAmount = parseFloat(this.customAmount).toFixed(2);
    },
    showAlert: function(){
      this.$notify({ type: 'danger', message: 'Please enter minimum amount or due amount' })
    },
    renderWelcomeEmail: async function(registration, suppliedHtml = null) {
      let html = registration.type && registration.type.welcomeEmail ? registration.type.welcomeEmail : "";
      if(suppliedHtml) html = suppliedHtml

      html = html.replace(new RegExp("confirmation_number", "g"), registration.confirmationNumber);

      for(let i = 0; i<registration.fields.length; i++){
        let field = registration.fields[i];

        let foundAllregistrants = html.search(new RegExp(`allregistrants.${field.name}`, 'g'))

        if(foundAllregistrants > 0){
          const values = await this.getAllFieldRelatedValues(field.name, registration)
          html = html.replace(new RegExp(`allregistrants.${field.name}`, 'g'), values)
        }

        if (field.type === "checkboxes") {
          let text = "";
          field.value.forEach(value => {
            text +=
              field.labels.split("\n")[
                field.values.split("\n").indexOf(value)
              ] + " ";
          });
          html = html.replace(new RegExp(field.name, "g"), text);
        } else if (field.type === "radio" || field.type === "list") {
          html = html.replace(
            new RegExp(field.name, "g"),
            field.labels.split("\n")[
              field.values.split("\n").indexOf(field.value)
            ]
          );
        } else {
          html = html.replace(new RegExp(field.name, "g"), field.value);
        }
      };

      html = html.replace(/\$|{|}/g, "");
      return html;
    },
    async getAllFieldRelatedValues(fieldName, registration) {
      let htmlStr = ""
      const allRegistrants = (await http.get(`/api/registrations/all-by-confirmation-number/${registration.confirmationNumber}/${registration.event._id}`)).data.registrations

      allRegistrants.sort((a, _) => {
        if(a.parent){
          return 1
        }
        return -1
      })

      for(let i=0; i<allRegistrants.length; i++){
        htmlStr += `<span>${await this.renderWelcomeEmail(allRegistrants[i], fieldName)}</span>`
      }

      htmlStr = `<span style="display: inline-flex; flex-direction: column; gap:10px;">${htmlStr}</span>`

      return htmlStr;
    },
    onPaymentSuccess: function(info) {
      swal.fire("Payment Successful!", "Payment successfully made. We will email you with the updated status shortly.", "success");
      if (this.registration.event.onlinePaymentProcessingFee){
        this.registration.paid = this.registration.paid + ( (parseFloat(this.customAmount)*100)/(100+this.registration.event.onlinePaymentProcessingFee) );

      }else{
        this.registration.paid = this.registration.paid + parseFloat(this.customAmount);
      }

      this.registration.due =
        this.registration.total - this.registration.paid;
      this.customAmountInput = this.registration.due;
      this.registration.status = 'confirmed'
      // setTimeout(()=>{
      //   console.log('@@Test');
      //   this.getRegistration();
      //   this.checkUserToken();
      // }, 3000)
    },
    getEmailFromRegistration: function(registration){
      return registration.find(field => field.fieldMapping === "email")
    }
  },
  filters: {
    startDate: value => moment.utc(value).format("DD-MMMM-YYYY HH:mm"),
    endDate: value => moment.utc(value).format("DD-MMMM-YYYY HH:mm"),
    registrationDate: value => moment(value).format("DD MMM YYYY HH:mm"),
    firstName: registration => {
      let firstName = "";
      const mapping = registration.fields.find(
        field => field.fieldMapping === "firstName"
      );
      if (mapping) {
        firstName = mapping.value;
      }

      return firstName;
    },
    lastName: registration => {
      let lastName = "";
      const mapping = registration.fields.find(
        field => field.fieldMapping === "lastName"
      );
      if (mapping) {
        lastName = mapping.value;
      }

      return lastName;
    },
    email: registration => {
      let email = "";
      const mapping = registration.fields.find(
        field => field.fieldMapping === "email"
      );
      if (mapping) {
        email = mapping.value;
      }

      return email;
    },
    name: registration => {
      let firstName = registration.fields.find(
        field => field.fieldMapping === "firstName"
      );
      firstName = firstName ? firstName.value : "";

      let lastName = registration.fields.find(
        field => field.fieldMapping === "lastName"
      );
      lastName = lastName ? lastName.value : "";

      return firstName + " " + lastName;
    },
    displayActivity: value =>{
      return `( ${value.join(', ')} )`
    },
  }
};
</script>
